import $ from 'jquery';

export default function magnificPopup() {
  
  function init() {
    $('.popup-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Caricamento immagine #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">L\'immagine #%curr%</a> non � stata caricata.',
        titleSrc: function(item) {
          return item.el.attr('title');
        }
      }
    });
  }
  
  if($('.popup-gallery').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/assets/js/popup-gallery.js